//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Mobile, PC } from "../../media/MediaQuery";

//css
import styled from "styled-components";

//img
import BackSvg from "../../assets/img/icon/back.svg";
import UserSvg from "../../assets/img/icon/icon_user.svg";
import CartSvg from "../../assets/img/icon/icon_cart.svg";
import HeaderSvg from "../../assets/img/icon/icon_heart.svg";

// component
import modalScroll from "../../utils/ModalScroll";

export default function HeaderMbSub(props) {
    //페이지 이동
    const navigate = useNavigate();

    const goWishPage = () => {
        navigate(`/wish`);
    };

    return (
        <Mobile>
            <Background
                active={props.mbMenuOpen}
                onClick={() => {
                    props.setmbMenuOpen(false);
                    modalScroll.modalClosed();
                }}
            />
            <Container active={props.mbMenuOpen}>
                {/* <Container on={props.mbMenuOpen} show={modalScroll.modalOpen()}> */}
                <BackBtnWrap
                    onClick={() => {
                        props.setmbMenuOpen(false);
                        modalScroll.modalClosed();
                    }}
                >
                    <BackIcon src={BackSvg} alt="닫기" />
                </BackBtnWrap>
                {props.isLogin ? (
                    <UtilWrap>
                        <UtilList
                            onClick={() => {
                                goWishPage();
                            }}
                        >
                            <HeartImg src={HeaderSvg} alt="위시리스트 아이콘" />
                            {/* wish리스트 안에 리스트가 0일땐 안보이게해주세요! */}
                            <CountWrap>
                                <Count>5</Count>
                            </CountWrap>
                        </UtilList>
                        <UtilList>
                            <UtilLink to="/">Logout</UtilLink>
                        </UtilList>
                    </UtilWrap>
                ) : (
                    <UtilWrap>
                        <UtilList>
                            <UtilLink to="/login">Login</UtilLink>
                        </UtilList>
                        <UtilList>
                            <UtilLink to="/signup">Sign up</UtilLink>
                        </UtilList>
                    </UtilWrap>
                )}
                <Bar />
                {props.preOrder == false && (
                    <NavWrap>
                        <NavList>
                            <NavLink to="/product">3D PRT</NavLink>
                        </NavList>
                        <NavList>
                            <NavLink to="/">Option</NavLink>
                        </NavList>
                        <NavList>
                            <NavLink to="/">Supplies</NavLink>
                        </NavList>
                        <NavList>
                            <NavLink to="/">AS part</NavLink>
                        </NavList>
                        <NavList gray>
                            <NavLink to="/">OPTION</NavLink>
                        </NavList>
                        <NavList gray>
                            <NavLink to="/">OPTION</NavLink>
                        </NavList>
                        <NavList gray>
                            <NavLink to="/">OPTION</NavLink>
                        </NavList>
                        <NavList gray>
                            <NavLink to="/">OPTION</NavLink>
                        </NavList>
                    </NavWrap>
                )}
            </Container>
        </Mobile>
    );
}

const Background = styled.div`
    content: "";
    position: fixed;
    top: 0;
    left: 0;
    display: none;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);

    z-index: 10;

    ${({ active }) => {
        return active && `display: block;`;
    }}
`;

const Container = styled.div`
    position: fixed;
    top: 0;
    left: 0;

    width: calc(100vw * (323 / 428));
    height: 100vh;
    background-color: #fff;

    z-index: 30;

    transition: all 0.4s;

    ${({ active }) => {
        return active ? `left: 0;` : `left: -100%;`;
    }}
`;

const BackBtnWrap = styled.div`
    display: flex;
    align-items: center;

    width: calc(100vw * (273 / 428));
    height: calc(100vw * (51 / 428));

    margin: 0 auto calc(100vw * (28 / 428));
    cursor: pointer;
`;

const BackIcon = styled.img`
    width: calc(100vw * (12 / 428));
    height: calc(100vw * (18 / 428));
`;

const UtilWrap = styled.ul`
    width: calc(100vw * (273 / 428));
    display: flex;
    justify-content: flex-end;

    margin: 0 auto calc(100vw * (30 / 428));
    padding-right: calc(100vw * (5 / 428));
`;

const UtilList = styled.li`
    position: relative;

    &:not(:first-child) {
        margin-left: calc(100vw * (30 / 428));
    }
`;

const Bar = styled.p`
    background: #eee;
    width: 100%;
    height: 1px;
`;

const CartImg = styled.img`
    width: calc(100vw * (21 / 428));
    height: calc(100vw * (21 / 428));
`;

const UserImg = styled.img`
    width: calc(100vw * (16 / 428));
    height: calc(100vw * (20 / 428));
`;

const HeartImg = styled.img`
    width: calc(100vw * (21 / 428));
    height: calc(100vw * (21 / 428));
`;

const UtilLink = styled(Link)`
    display: block;
    font-family: "Pop-M";

    font-size: calc(100vw * (13 / 428));
`;

const CountWrap = styled.div`
    position: absolute;
    top: calc(100vw * (-5 / 428));
    right: calc(100vw * (-12 / 428));

    display: flex;
    width: calc(100vw * (18 / 428));
    height: calc(100vw * (18 / 428));

    border: 1px solid #fff;
    background: var(--main-color);

    border-radius: 50%;
`;

const Count = styled.p`
    font-family: "Pop-M";
    font-size: calc(100vw * (10 / 428));
    color: #fff;

    margin: auto;
`;

const NavWrap = styled.ul`
    width: calc(100vw * (273 / 428));
    margin: 0 auto;

    padding: 0 calc(100vw * (15 / 428));
`;

const NavList = styled.li`
    margin-top: calc(100vw * (30 / 428));

    ${({ gray }) => {
        return (
            gray &&
            `
                & a{color:#CECECE;}
            `
        );
    }}
`;

const NavLink = styled(Link)`
    display: block;
    font-family: "Pop-M";
    font-size: calc(100vw * (14 / 428));
`;
